/**
 * esta foi a única maneira que encontrei para deixar o cabeçalho do grid de itens fixo,
 * não afetando o scroll vertical e horizontal.
 * as soluções mais comuns para este problema não funcionaram devido à maneira como o frontend foi feito
 * 
 * Jonathan Bispo
 */

const DESATIVAR_SCROLLS = true

export function ativarScrollVerticalGridItens() {
    if (DESATIVAR_SCROLLS) {
        console.log('os scrolls foram desativados via DESATIVAR_SCROLLS = true')
        return
    }

    $(window).unbind('scroll')

    $(window).on('scroll', function () {

        var valorScrollWindow = $(window).scrollTop()
        var decremento = 85;
        var valorTop = valorScrollWindow - decremento > 0 ? valorScrollWindow - decremento : 0
        $("#tabela-produtos thead th").css("top", valorTop + "px")

    })
}

export function desativarScrollVerticalGridItens() {
    if (DESATIVAR_SCROLLS) {
        console.log('os scrolls foram desativados via DESATIVAR_SCROLLS = true')
        return
    }

    $(window).unbind('scroll')
    $("#tabela-produtos thead th").css("top", "0px")
}

export function ativarScrollHorizontalGridItens() {

     if (DESATIVAR_SCROLLS) {
        console.log('os scrolls foram desativados via DESATIVAR_SCROLLS = true')
        return
    }

    $("#tabela-itens-orcamento-region").unbind('scroll')

    $("#tabela-itens-orcamento-region").on('scroll', function () {

        var valorScroll = $("#tabela-itens-orcamento-region").scrollLeft()



        $("#tabela-produtos > thead > tr > th:nth-child(1)").css("left", valorScroll + "px")
        $("#tabela-produtos > thead > tr > th:nth-child(2)").css("left", valorScroll + "px")
        $("#tabela-produtos > thead > tr > th:nth-child(3)").css("left", valorScroll + "px")
        $("#tabela-produtos > thead > tr > th:nth-child(4)").css("left", valorScroll + "px")

        $("#tabela-produtos > tbody > tr > td:nth-child(1)").css("left", valorScroll + "px")
        $("#tabela-produtos > tbody > tr > td:nth-child(2)").css("left", valorScroll + "px")
        $("#tabela-produtos > tbody > tr > td:nth-child(3)").css("left", valorScroll + "px")
        $("#tabela-produtos > tbody > tr > td:nth-child(4)").css("left", valorScroll + "px")


    })
}

export function desativarScrollHorizontalGridItens() {
    if (DESATIVAR_SCROLLS) {
        console.log('os scrolls foram desativados via DESATIVAR_SCROLLS = true')
        return
    }

    $("#tabela-itens-orcamento-region").unbind('scroll')

    $("#tabela-produtos > thead > tr > th:nth-child(1)").css("left", "0px")
    $("#tabela-produtos > thead > tr > th:nth-child(2)").css("left", "0px")
    $("#tabela-produtos > thead > tr > th:nth-child(3)").css("left", "0px")
    $("#tabela-produtos > thead > tr > th:nth-child(4)").css("left", "0px")

    $("#tabela-produtos > tbody > tr > td:nth-child(1)").css("left", "0px")
    $("#tabela-produtos > tbody > tr > td:nth-child(2)").css("left", "0px")
    $("#tabela-produtos > tbody > tr > td:nth-child(3)").css("left", "0px")
    $("#tabela-produtos > tbody > tr > td:nth-child(4)").css("left", "0px")
}

/**
 * nem de longe esta é a maneira correta de resolver o problema, mas dada a complexidade de manutenção desse frontend
 * e o tempo para corrigir, foi única opção.
 * este hack corrige o problema de seleção de itens no grid depois que foram introduzidos os scroll
 * vertical e horizontal para melhorar a usabilidade. por algum motivo as colunas fixas ficavam atrás da linha selecionada.
 * mexer no scroll ativa a função que corrige este posicionamento
 * 
 * Jonathan Bispo
 */
export function hackCorrigirProblemaAposSelecaoDeItens() {
    if (DESATIVAR_SCROLLS) {
        console.log('os scrolls foram desativados via DESATIVAR_SCROLLS = true')
        return
    }
    
    var region = $("#tabela-itens-orcamento-region")

    if (region != null) {

        var scrollLeftAtual = region.scrollLeft()
        region.scrollLeft(scrollLeftAtual + 1)
        region.scrollLeft(scrollLeftAtual - 1)
    }
}